export * from "./sedan-icon.component";
